/**
 * Electron 环境检测工具
 */

/**
 * 检测是否在 Electron 环境中
 * @returns {boolean}
 */
export function isElectron() {
  // 更严格的检测：必须同时满足 electronAPI 存在且可用
  if (typeof window === 'undefined') {
    return false
  }
  
  // 检查 electronAPI 是否存在且包含必要的方法
  if (window.electronAPI && typeof window.electronAPI.openDirectoryDialog === 'function') {
    return true
  }
  
  // 检查 userAgent（备用检测方式）
  if (window.navigator?.userAgent?.indexOf('Electron') !== -1) {
    return true
  }
  
  // 检查协议（备用检测方式，但需要谨慎，因为某些浏览器可能也使用 file://）
  if (window.location?.protocol === 'file:' && window.electronAPI) {
    return true
  }
  
  return false
}

/**
 * 获取 Electron API（如果可用）
 * @returns {object|null}
 */
export function getElectronAPI() {
  return isElectron() ? window.electronAPI : null
}
